import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '@gan/core/util-environment';

import { OpsNotificationModel } from '../models';

@Injectable({ providedIn: 'root' })
export class OpsNotificationsService {
  private http = inject(HttpClient);

  getOpsNotifications(): Observable<OpsNotificationModel[]> {
    return this.http.get<OpsNotificationModel[]>(`${environment.API_URL}/ops-notifications`);
  }
}
